import { useLocation } from 'react-router-dom';
import { useAppSelector } from './redux';

/**
 * Custom hook that detects whether the current path has changed.
 *
 * @param {string} path - The path to compare against.
 * @returns {boolean} - Returns `true` if the current path has changed and there are unsaved changes,
 * or if the current path is different from the given path. Otherwise, returns `false`.
 */
export const useDetectPathChanged = (path: string) => {
  const location = useLocation();
  const { hasUnsavedChanges } = useAppSelector((state) => state.savedChanges);
  const currentPath = location.pathname === path;

  if (!currentPath && !hasUnsavedChanges) return false;
  return true;
};
